






import Component, { mixins } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import InputFileMixin from "@/mixins/InputFileMixin";
import { isSafari } from "@/lib/browserUtils";
import { getElement } from "@/lib/elementHelpers";
import { getNameMimeType } from "@/lib/fileHelpers";
import config from "@/config";

const inputFileMixin = InputFileMixin(config.fileTypes);

@Component({ name: "DragDropFiles" })
export default class DragDropFiles extends mixins(inputFileMixin) {
  @Prop({ type: Boolean, default: false })
  public readonly multiple!: boolean;

  public isDrag = false;

  public isDragOverWrapper = false;

  public get wrapperElement() {
    return getElement<HTMLElement>(this.$refs.wrapper);
  }

  public onDragIn(e: DragEvent) {
    e.preventDefault();
    this.isDrag = true;
    if (e.target === this.wrapperElement) {
      this.isDragOverWrapper = true;
    }
  }

  public onDragOut(e: DragEvent) {
    e.preventDefault();
    if (e.target === this.wrapperElement) {
      this.isDragOverWrapper = false;
    }
    if ((!isSafari() && e.relatedTarget === null) || (isSafari() && e.target === this.wrapperElement)) {
      this.isDrag = false;
    }
  }

  public onDrop(e: DragEvent) {
    e.preventDefault();
    try {
      if (e.target === this.wrapperElement && e.dataTransfer && e.dataTransfer.files.length > 0) {
        const files = Array.from(e.dataTransfer.files).filter(f => {
          let type = getNameMimeType(f.name);
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          return !this.accept || (type && this.acceptTypes.includes(type));
        });
        if (files.length > 0) {
          this.$emit("input", this.multiple ? files : files.slice(0, 1));
        }
      }
    } finally {
      this.isDrag = false;
      this.isDragOverWrapper = false;
    }
  }

  public async mounted() {
    if (isSafari()) {
      this.wrapperElement.addEventListener("dragenter", this.onDragIn);
      this.wrapperElement.addEventListener("dragover", this.onDragIn);
      this.wrapperElement.addEventListener("dragleave", this.onDragOut);
      this.wrapperElement.addEventListener("drop", this.onDrop);
    } else {
      window.addEventListener("dragenter", this.onDragIn);
      window.addEventListener("dragover", this.onDragIn);
      window.addEventListener("dragleave", this.onDragOut);
      window.addEventListener("drop", this.onDrop);
    }
  }

  public beforeDestroy() {
    if (isSafari()) {
      this.wrapperElement.removeEventListener("dragenter", this.onDragIn);
      this.wrapperElement.removeEventListener("dragover", this.onDragIn);
      this.wrapperElement.removeEventListener("dragleave", this.onDragOut);
      this.wrapperElement.removeEventListener("drop", this.onDrop);
    } else {
      window.removeEventListener("dragenter", this.onDragIn);
      window.removeEventListener("dragover", this.onDragIn);
      window.removeEventListener("dragleave", this.onDragOut);
      window.removeEventListener("drop", this.onDrop);
    }
  }
}
